import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";

import dealerService from "../services/dealer.service";

import EventBus from "../utils/EventBus";
import challanService from "../services/challan.service";

export const createchallan = createAsyncThunk(
  "api/createchallan",
  async (stateData, thunkAPI) => {
    try {
      const data = await challanService.createNewChallan(stateData);
      return { challandata: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getchallan = createAsyncThunk(
  "api/getchallan",
  async (thunkAPI) => {
    try {
      const data = await challanService.getChallan();
      return { challandata: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
        console.log(error.response.status);
        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

const initialState ={
    challan: []
}

const challanSlice = createSlice({
  name: "api",
  initialState,
  extraReducers: {
    [createchallan.fulfilled]: (state, action) => {
      console.log("vasanth", action.payload)
      state.challan.push(action.payload.challandata.data)
      return state;
    },
    [createchallan.rejected]: (state, action) => {
      state.challan = action.payload.challandata
      return state;
    },
    [getchallan.fulfilled]: (state, action) => {
    state.challan = action.payload.challandata.data !== null ? action.payload.challandata.data : []
    return state;
  },
  [getchallan.rejected]: (state, action) => {
    state.dealers = action.payload.challandata
    return state;
  }
  },
});

const { reducer } = challanSlice;
export default reducer;